import * as React from "react";
import * as ReactDOM from "react-dom";
import LogCompanyTooltip from "../../common/controls/LogCompanyTooltip";

interface IProps {
	value: string,
}

export default {
	init: (rootElement: HTMLElement, value: string) => {
		return ReactDOM.render(
			<React.Suspense fallback="loading">
				<LogCompanyTooltip
					value={value}
				/>
			</React.Suspense>,
		rootElement);
	}
} 